export const BadgeOrderType = {
  LATEST: 'LATEST',
  OLDEST: 'OLDEST',
  RANDOM: 'RANDOM',
};

export const badgeOrderTypes = [
  BadgeOrderType.LATEST,
  BadgeOrderType.OLDEST,
  BadgeOrderType.RANDOM,
];
